import { SVGProps } from 'react';

const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 20 20" {...props}>
    <path stroke="#292929" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m5 7.5 5 5 5-5" />
  </svg>
);

export default SvgArrowDown;
